import * as actionTypes from "./actionTypes";

export const routerNotifTop = (status) => {
  return {
    type: actionTypes.ROUTER_NOTIF_TOP,
    status: status,
  };
};

export const routerUpdate = (routerKey) => {
  return {
    type: actionTypes.ROUTER_CHOOSE,
    routerKey: routerKey,
  };
};
